import { render } from "./choseSeat.vue?vue&type=template&id=dd2bd1ea&scoped=true"
import script from "./choseSeat.vue?vue&type=script&lang=js"
export * from "./choseSeat.vue?vue&type=script&lang=js"

import "./choseSeat.vue?vue&type=style&index=0&id=dd2bd1ea&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2bd1ea"],['__file',"src/components/public/choseSeat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd2bd1ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd2bd1ea', __exports__)) {
    console.log('reload')
    api.reload('dd2bd1ea', __exports__)
  }
  
  module.hot.accept("./choseSeat.vue?vue&type=template&id=dd2bd1ea&scoped=true", () => {
    console.log('re-render')
    api.rerender('dd2bd1ea', render)
  })

}


export default __exports__